var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        width: _vm.getNavWidth(),
        height: _vm.getNavHeight(),
        value:
          (_vm.isCheckoutPageOnDesktop || _vm.showCart) && !_vm.disabledCart,
        temporary: !_vm.isCheckoutPageOnDesktop,
        app: !_vm.isCheckoutPageOnDesktop,
        "disable-resize-watcher": _vm.isCheckoutPageOnDesktop,
        permanent:
          (_vm.isCheckoutPageOnDesktop && !_vm.disabledCart) ||
          _vm.navPermanent,
        right: "",
        absolute: "",
        clipped: "",
        overflow: ""
      },
      on: { input: _vm.toggleCart }
    },
    [
      _c("SideContent", {
        class: _vm.$style.cartContent,
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("button", { class: _vm.$style.pastOrdersClose }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.isCheckoutPageOnDesktop
                          ? "Order Details"
                          : "Your Cart"
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style.cartTitle },
                  [
                    _c(
                      "div",
                      { class: _vm.$style.cartTitleLogo },
                      [_c("Logo")],
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { class: _vm.$style.cartMainTitle }, [
                      _c("span", [_vm._v("Review Your Order")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "BaseButton",
                      {
                        class: _vm.$style.closeDialog,
                        attrs: { "button-style": "Back" },
                        on: {
                          click: function($event) {
                            _vm.setNavPermanent(false), _vm.toggleCart(false)
                          }
                        }
                      },
                      [
                        _c("svg", {
                          directives: [{ name: "svg", rawName: "v-svg" }],
                          class: _vm.$style.backIcon,
                          attrs: { symbol: "straight-arrow" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Back")])
                      ]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "main",
            fn: function() {
              return [
                _c("div", { class: _vm.$style.currentOrderCart }, [
                  _c(
                    "div",
                    { class: _vm.$style.currentOrderItems },
                    _vm._l(_vm.cart, function(value, key) {
                      return _c("CartProduct", {
                        key: key,
                        class: _vm.$style.currentOrderItem,
                        attrs: {
                          "order-item-id": key,
                          disabled: _vm.isCheckoutPageOnDesktop
                        },
                        on: {
                          "change-quantity": function($event) {
                            return _vm.changeQuantity(key, $event)
                          },
                          edit: _vm.handleEditItem
                        }
                      })
                    }),
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _vm.currentPage !== "checkout" || _vm.isDesktopResolution
                  ? _c("CartTotal", {
                      attrs: { "current-page": _vm.currentPage },
                      on: {
                        "add-item": _vm.handleAddItem,
                        "start-over": _vm.handleStartOver,
                        checkout: _vm.checkout
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/cart/components/Cart.vue?vue&type=template&id=84027fc4&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 